module.exports = __webpack_public_path__ + "static/media/08b.4f3026cd.png";